<template>
  <NavBar :isAuth="isAuth" v-if="isAuth || !isAuth" :links="links" />
  <v-container fluid class="ma-0 pa-0 mt-10">
    <v-row>
      <!-- <HomeComponent :dir="dir" /> -->
      <router-view />
    </v-row>
  </v-container>
</template>

<script>
import { defineComponent } from "vue";

import NavBar from "../../components/NavBar.vue";
// import HomeComponent from "../components/HomeComponent.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    NavBar,
    // HomeComponent,
  },
  data() {
    return {
      links: [
        {
          path: "/acc",
          title: "Home",
        },
        {
          path: "/acc/actions",
          title: "الحركات",
        },
        {
          path: "/acc/messages",
          title: "الرسائل",
        },
      ],
    };
  },
  computed: {
    dir() {
      return this.$i18n.messages[this.$i18n.locale].dir;
    },
    isAuth() {
      return this.$route.matched.some((record) => record.meta.auth);
    },
    // role() {
    //   return this.$route.meta.role;
    // },
  },
  mounted() {
    //const url = process.env;
    //console.log(url); // should output the value of VUE_APP_URL
  },
});
</script>
